module.exports = __webpack_public_path__ + "img/logo_blanco.0d5c4b3d.png";